import PestPillarLayout from "../PestPillarLayout";

const PROBLEMS = [
  {
    title: "Frelons et guêpes à Guéret",
    desc: "Nids en toiture d'immeubles, dans les jardins des quartiers résidentiels de Guéret et alentours (Sainte-Feyre, Saint-Fiel). Intervention rapide en centre-ville et périphérie.",
  },
  {
    title: "Rats et souris en ville",
    desc: "Guéret, préfecture de la Creuse, connaît une pression rongeurs élevée en centre-ville (commerces, restauration, immeubles anciens). Dératisation raisonnée pour particuliers et professionnels.",
  },
  {
    title: "Punaises de lit",
    desc: "Hôtels, gîtes, résidence étudiante IUT, appartements en location : nous intervenons en toute discrétion à Guéret avec la méthode vapeur sèche 180 °C.",
  },
  {
    title: "Cafards et blattes",
    desc: "Restauration, boulangeries et cuisines collectives à Guéret. Traitement HACCP-compatible avec certificat d'intervention.",
  },
  {
    title: "Chenilles processionnaires",
    desc: "Le parc de Chabrières et les jardins guérétois abritent des pins accueillant chenilles processionnaires. Échenillage manuel et éco-pièges.",
  },
  {
    title: "Désinfection après sinistre",
    desc: "Dégât des eaux, décès à domicile, infestation ancienne : désinfection complète de logements et locaux professionnels à Guéret.",
  },
];

const FAQ = [
  {
    q: "Quel délai pour intervenir à Guéret ?",
    a: "Guéret est à 30 minutes de notre siège à La Celle-Dunoise. En pleine saison (avril à octobre), nous intervenons sous 24-48 h pour les demandes standards et dans la journée pour les urgences (nid de frelons actif, invasion massive).",
  },
  {
    q: "Combien coûte une destruction de nid de frelons à Guéret ?",
    a: "Entre 90 € et 180 € selon la hauteur et l'accessibilité du nid. Un nid en toiture standard (jusqu'à 6 m) est facturé environ 110 €. Devis gratuit sur photo. Aucun frais de déplacement en centre-ville de Guéret.",
  },
  {
    q: "Intervenez-vous dans les copropriétés à Guéret ?",
    a: "Oui, nous travaillons régulièrement avec des syndics de copropriété à Guéret pour la dératisation d'immeubles, la destruction de nids en parties communes ou le traitement anti-punaises en logements collectifs. Devis groupé disponible.",
  },
  {
    q: "Traitez-vous les gîtes touristiques à Guéret ?",
    a: "Oui, nous proposons des contrats de prévention annuels aux hébergeurs touristiques de Guéret et Creuse : passages de contrôle, désinfection en fin de saison, intervention prioritaire en cas de suspicion punaise de lit. Confidentialité totale.",
  },
];

export default function AntiNuisiblesGueret() {
  return (
    <PestPillarLayout
      slug="anti-nuisibles-gueret"
      seoTitle="Anti-nuisibles Guéret (23) — Frelons, punaises | K'REUSE"
      seoDescription="Anti-nuisibles à Guéret (23) : frelons, rats, punaises de lit, cafards. Intervention sous 24h, Certibiocide. 07 80 54 11 15."
      breadcrumbLabel="Anti-nuisibles Guéret"
      heroBadge="Guéret · Creuse (23)"
      heroTitleHtml={`Anti-nuisibles à <span class="font-medium text-[#1B5E20]">Guéret</span>`}
      heroSubtitle="Frelons, guêpes, rats, souris, punaises de lit, cafards, chenilles processionnaires : nous intervenons à Guéret et ses alentours (Sainte-Feyre, Saint-Fiel, La Saunière) en 24-48 h."
      hero_h2="Votre entreprise anti-nuisibles à Guéret"
      introParagraphs={[
        "Guéret, préfecture de la Creuse, cumule les défis anti-nuisibles typiques des villes rurales : bâti ancien favorisant les rongeurs, jardins offrant des sites de nidification aux frelons asiatiques, hébergements touristiques exposés aux punaises de lit importées, et parc urbain de Chabrières où prolifèrent les chenilles processionnaires du pin.",
        "K'REUSE EXTÉRIEUR intervient à Guéret depuis notre siège de La Celle-Dunoise (30 minutes) avec un déplacement rapide sous 24-48 h. Nous couvrons tous les quartiers : centre-ville, l'Assolant, Grancher, le Grand-Bourg, Sainte-Feyre, Saint-Fiel. Aucun frais de déplacement supplémentaire par rapport à nos tarifs de base.",
        "Notre équipe est certifiée Certibiocide et intervient aussi bien pour les particuliers (maisons, appartements, jardins) que pour les professionnels (syndics de copropriété, hôteliers, restaurateurs, commerces, boulangeries). Confidentialité totale et attestation d'intervention systématique pour les professionnels HACCP.",
      ]}
      problems={PROBLEMS}
      method={[
        { title: "Contact", desc: "Appel, WhatsApp ou formulaire. Diagnostic à distance ou visite programmée sous 24-48 h à Guéret." },
        { title: "Devis clair", desc: "Devis gratuit détaillé sans surprise. Certibiocide garantit un traitement conforme." },
        { title: "Intervention", desc: "Déplacement à Guéret avec le matériel adapté. Confidentialité totale, respect des locaux." },
        { title: "Suivi", desc: "Contrôle post-intervention selon la nature du traitement. Garantie de résultat sur nos protocoles." },
      ]}
      cities={["Sainte-Feyre", "Saint-Fiel", "La Saunière", "Anzême", "Ajain", "Saint-Sulpice-le-Guérétois", "Saint-Christophe", "Saint-Vaury"]}
      faq={FAQ}
      ctaTitle="Un problème de nuisibles à Guéret ?"
      whatsappText="Bonjour, j'ai besoin d'une intervention anti-nuisibles à Guéret."
    />
  );
}
